// Изборът на маса за „Нова резервация" — общ за схемата (useTablePicker) и
// мобилния списък с плочки (MobileTablePicker), за да не се разминават.

/** Какво знае изборът за заетостта и избраното (подмножество на `NewReservationForm`). */
export interface PickContext {
  selectedIds: readonly number[];
  busyTableIds: ReadonlySet<number>;
  // Масите на редактираната резервация при непроменен час — не са „заети" за нея.
  reclaimableTableIds: ReadonlySet<number>;
  // Заетостта на деня се зарежда или не се зареди.
  isDayUnknown: boolean;
  guests: number;
}

/**
 * - `selected` — избрана (може да се махне винаги)
 * - `unknown` — заетостта не е ясна, масата не се избира
 * - `busy` — заета в интервала, некликаема
 * - `fits` / `free` — свободна, побира / не побира гостите
 */
export type PickState = "selected" | "unknown" | "busy" | "fits" | "free";

export const pickStateOf = (table: { id: number; seats: number }, context: PickContext): PickState => {
  if (context.selectedIds.includes(table.id)) return "selected";
  const reclaimable = context.reclaimableTableIds.has(table.id);
  if (context.isDayUnknown && !reclaimable) return "unknown";
  if (context.busyTableIds.has(table.id) && !reclaimable) return "busy";
  return table.seats >= context.guests ? "fits" : "free";
};

/** Кликът избира/маха масата — не и заета или с неясна заетост. */
export const canTogglePick = (state: PickState) => state !== "unknown" && state !== "busy";
